import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
    CmpsIconModule,
    CmpsIconRegistry,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';
import {
    mdiCheck,
    mdiChevronRight,
    mdiClose,
    mdiDotsVertical,
    mdiTrendingDown,
    mdiTrendingNeutral,
    mdiTrendingUp,
} from '@mdi/js';

import { CmpsCardDataRowComponent } from './card-data-row.component';

@NgModule({
    declarations: [CmpsCardDataRowComponent],
    imports: [CmpsIconModule, CommonModule, CmpsTooltipModule],
    exports: [CmpsCardDataRowComponent],
})
export class CmpsCardDataRowModule {
    constructor(
        private readonly _domSanitizer: DomSanitizer,
        private readonly _iconRegistry: CmpsIconRegistry,
    ) {
        [
            ['trend-up', mdiTrendingUp],
            ['trend-down', mdiTrendingDown],
            ['trend-neutral', mdiTrendingNeutral],
            ['dots', mdiDotsVertical],
            ['chevron-right', mdiChevronRight],
            ['close', mdiClose],
            ['check', mdiCheck],
        ].forEach(([name, icon]) => {
            _iconRegistry.addSvgIconFromHtml(
                name,
                _domSanitizer.bypassSecurityTrustHtml(
                    `<svg id="${name}"><path d="${icon}"></path></svg>`,
                ),
                '__internal',
            );
        });
    }
}
